import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { UploadButton } from "@/components/UploadButton";
import { toast } from "sonner";

export default function AdminTransports() {
  const [items, setItems] = useState([]);
const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    name: "",
    description: "",
    logo: "",
  });

  const loadData = async () => {
    try {
      const { data } = await api.get("/admin/master/transports");
      setItems(data);
    } catch {
      toast.error("Gagal memuat data transport");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

const saveTransport = async () => {
  try {

    if (editingId) {
      await api.put(
        `/admin/master/transports/${editingId}`,
        form
      );

      toast.success("Transport berhasil diupdate");
    } else {
      await api.post(
        "/admin/master/transports",
        form
      );

      toast.success("Transport berhasil ditambahkan");
    }

    setEditingId(null);

    setForm({
      name: "",
      description: "",
      logo: "",
    });

    loadData();

  } catch {
    toast.error("Gagal menyimpan transport");
  }
};
  const deleteTransport = async (id) => {
    if (!window.confirm("Hapus transport ini?")) return;

    try {
      await api.delete(`/admin/master/transports/${id}`);
      toast.success("Transport berhasil dihapus");
      loadData();
    } catch {
      toast.error("Gagal menghapus transport");
    }
  };

const editTransport = (item) => {
  setEditingId(item.id);

  setForm({
    name: item.name || "",
    description: item.description || "",
    logo: item.logo || "",
  });

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">
          Master Transport
        </h1>
      </div>

      <div className="grid gap-3">

        <input
          className="border rounded px-3 py-2"
          placeholder="Transport Name"
          value={form.name}
          onChange={(e) =>
            setForm({
              ...form,
              name: e.target.value,
            })
          }
        />

<textarea
  className="border rounded px-3 py-2"
  rows={4}
  placeholder="Deskripsi Transport"
  value={form.description || ""}
  onChange={(e) =>
    setForm({
      ...form,
      description: e.target.value,
    })
  }
/>

        <div className="space-y-2">
          <UploadButton
            label="Upload Transport Logo"
            onUploaded={(url) =>
              setForm({
                ...form,
                logo: url,
              })
            }
          />

          {form.logo && (
            <img
              src={form.logo}
              alt="Transport Preview"
              className="h-32 w-full object-contain rounded border bg-white"
            />
          )}
        </div>

      </div>

      <button
        onClick={saveTransport}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        {editingId
  ? "Update Transport"
  : "Tambah Transport"}
      </button>

      <table className="w-full border">
<thead>
  <tr className="bg-gray-100">
    <th className="border p-2">Logo</th>
    <th className="border p-2">Name</th>
    <th className="border p-2">Description</th>
    <th className="border p-2">Action</th>
  </tr>
</thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="border p-2">
  {item.logo ? (
    <img
      src={item.logo}
      alt=""
      className="h-12 w-20 object-contain"
    />
  ) : (
    "-"
  )}
</td>

<td className="border p-2">
  {item.name}
</td>

<td className="border p-2">
  {item.description || "-"}
</td>

<td className="border p-2">
  <div className="flex gap-3">

    <button
      onClick={() => editTransport(item)}
      className="text-blue-600"
    >
      Edit
    </button>

    <button
      onClick={() => deleteTransport(item.id)}
      className="text-red-600"
    >
      Hapus
    </button>

  </div>
</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
